/* eslint-disable */
import React from 'react';
import { Block } from 'slate';
import { getDroppedOrSelectedFiles } from 'html5-file-selector';
import styled from 'styled-components';
import Image from './Image';
// import { getDataTransferFiles } from './utils';

const HiddenInput = styled.input`
  position: absolute;
  visibility: hidden;
`;

async function onImagePicked(editor, event) {
  const files = await getDroppedOrSelectedFiles(event);
  files.forEach(file => editor.insertImageFile(file.fileObject));
}

function handleFileInputClick(event) {
  // reset value to make sure onChange handler gets triggered
  // even if the same file is uploaded twice in a row
  event.target.value = null; // eslint-disable-line
}

export default function imagePlugin({ handleUpload }) {
  return {
    schema: {
      blocks: {
        image: {
          isVoid: true,
        },
      },
    },

    commands: {
      insertImageFile(editor, file) {
        const placeholderSrc = URL.createObjectURL(file);
        const node = Block.create({
          type: 'image',
          isVoid: true,
          data: { placeholderSrc, isUploading: true },
        });
        editor
          .insertBlock(node)
          .withoutSaving((editor) => {
            // withoutSaving prevents this op from being added to the history
            // => undo will also remove placeholder
              handleUpload(file)
                .then((id) => {
                  if (!id) {
                    throw new Error('No media id returned from handleUpload callback');
                  }
                  // Replace placeholder with uploaded image
                  try {
                    editor.setNodeByKey(node.key, {
                      data: { id, isUploading: false, placeholderSrc },
                    });
                  } catch (err) {
                    // do nothing - user has removed
                  }
                })
                .catch((error) => {
                  alert('Could not upload image'); // eslint-disable-line
                  editor.removeNodeByKey(node.key);
                });
          })
        ;
      },
    },

    renderBlock(props, editor, next) {
      const { node } = props;
      if (node.type === 'image') {
        return <Image {...props} />;
      }
      return next();
    },

    renderEditor(props, editor, next) {
      const children = next();
      return (
        <>
          <HiddenInput
            type="file"
            onChange={event => onImagePicked(editor, event)}
            onClick={handleFileInputClick}
            accept="image/*"
            id="editor-image-input"
          />
          {children}
        </>
      );
    },
  };
}
